import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Chart, ChartData, ChartOptions } from 'chart.js';
import { KButtonType, KKcgButtonSubType } from 'ng-k-button';
import { BreachOfDutyService } from 'src/app/services/breach-of-duty.service';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import * as moment from 'moment';
import { IkTableData, KTableGridService } from 'ng-k-data-visualization';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseChartDirective } from 'ng2-charts';
import { OauthPlusService } from 'src/app/services/oauth-plus.service';
import { ClaimsService } from 'src/app/services/claims.service';
@Component({
  selector: 'app-establish-breach-of-duty',
  templateUrl: './establish-breach-of-duty.component.html',
  styleUrls: ['./establish-breach-of-duty.component.scss']
})
export class EstablishBreachOfDutyComponent implements OnInit {
  KButtonType = KButtonType;
  KKcgButtonSubType = KKcgButtonSubType;
  claimId = '';
  taskId = '';
  public sampleData = [];
  public data: any = [];
  public tableData!: IkTableData;
  public maxSize = 8;
  public totalDose = 0;
  public doseCausationAdvice = '';
  public customData: any;
  @ViewChild(BaseChartDirective) chart: BaseChartDirective| null = null;

  chartData: ChartData<'line'> = {
    labels: [],
    datasets: [
    ],
  };

  chartOptions: ChartOptions = {};

  constructor(
    private _auth: OauthPlusService,
    private loaderService: GlobalLoadingService,
    private breachOfDutyService: BreachOfDutyService,
    private kTableGridService: KTableGridService,
    private route: ActivatedRoute,
    private router: Router,
    private claimsService: ClaimsService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.claimId = params['claimId'];
      this.taskId = params['taskId'];
      });

    this._auth.$whenUserLoaded.subscribe(data=> {
      if(data) {
        this.getDoseSummaryList();
        this.getChartData();
      }
      this.getWorkflowOverview(this.claimId)
    });
  }

  public getWorkflowOverview(claimID: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimID ? claimID : null;
    this.loaderService.startLoadingIndicator('getWorkflowOverview');

    thisObj.claimsService.getWorkflowOverview(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getWorkflowOverview');
        this.customData = {
          claimId : this.claimId,
          claimantName : result.data.meta.claimant.claimantName,
          medicalConditionLabel: 'Asbestosis',
          medicalConditionValue: 'asbestosis'
        }
      }
    },
    err => {
    });
  }

  public getDoseSummaryList() {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId? this.claimId : null;
    requestParam.taskId = this.taskId? this.taskId : null;
    requestParam.actionName = 'dose_summary';
    requestParam.payload = {};
    this.loaderService.startLoadingIndicator('getDoseSummaryList');
    thisObj.breachOfDutyService.getDoseSummaryList(requestParam).subscribe(result => {
      // console.log(result.data)
      if (result.status === 'Success') {
        this.initiateTable(result.data.tasks);
        this.totalDose = result.data.total_dose;
        this.doseCausationAdvice = result.data.advice;
        this.loaderService.stopLoadingIndicator('getDoseSummaryList');
        // console.log(result);
      }  
    },
    err => {
      console.log('err')
      console.log(err.error);
      this.loaderService.stopLoadingIndicator('getDoseSummaryList');
    });
  }

  public getChartData() {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId? this.claimId : null;
    requestParam.taskId = this.taskId? this.taskId : null;
    requestParam.actionName = 'dose_summary_chart';
    requestParam.payload = {};
    this.loaderService.startLoadingIndicator('getChartData');
    thisObj.breachOfDutyService.getDoseSummaryList(requestParam).subscribe(result => {
      // console.log(result.data)
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getChartData');
        this.chartData.datasets=result.data.datasets;
        this.chartData.labels=result.data.labels;
        this.chartOptions?.plugins?.title?.text?  result.data.title : '';
        this.chartOptions = {
          elements: {
            point: {
              radius: 0
            },
          },
          responsive: true,
          scales: {
            x: {
              position: 'top'
            }
          },
          plugins: {
            title: {
              display: true,
              text: result.data.title,
            },
          },
        }
        if(this.chart) {
          this.chart?.chart?.update();  // Update the chart 
        }
      }  
    },
    err => {
      console.log('err')
      console.log(err.error);
      this.loaderService.stopLoadingIndicator('getChartData');
    });
  }

  goToPage() {
    this.router.navigate(['/claimDetail/',this.claimId]);
  }

  initiateTable(tableData: any) {
    this.sampleData = [];
    this.data = [];
      this.sampleData = tableData;
    
      if (this.sampleData.length > 0) {
        for (const data of this.sampleData) {
          const temp = [
            {
              label: data['_id'],
              isShow: false
            },
            {
              label: data['employer']['employer'],
            },
            {
              label: moment(new Date(data['startDate'])).format('DD/MM/YYYY') 
            },
            {
              label: moment(new Date(data['endDate'])).format('DD/MM/YYYY') 
            },
            {
              label: data['task']
            },
            {
              label: data['fiber']
            },
            {
              label: data['fml']
            },
            {
              label: data['twa']
            },
            {
              label: data['fmlPerMinute']
            },
            {
              label: data['exposedMm']
            },
            {
              label: data['distanceCorrection']
            },
            {
              label: data['days']
            },
            {
              label: data['dose']
            },
            {
              label: data['isBreach'] == true ? 'Yes' : 'No'
            }
          ];
          this.data.push(temp);
        }
      } else {
        const temp = [
          {
            label: 'No data found.',
            colspan: 12
          },
        ];
        this.data.push(temp);
      }
      this.tableDataInitialisation();
  }

  async tableDataInitialisation() {
    this.tableData = {
      header: [
        {
          label: 'Employer',
        },
        {
          label: 'From Date',
        },
        {
          label: 'To Date',
        },
        {
          label: 'Task',
        },
        {
          label: 'Fibre',
        },
        {
          label: 'Fibre/ml',
        },
        {
          label: 'TWA',
        },
        {
          label: '10 f/ml min',
        },
        {
          label: 'mm',
        },
        {
          label: 'Distance Correction',
        },
        {
          label: 'Days',
        },
        {
          label: 'Dose',
        },
        {
          label: 'Breached Status',
        }
      ],
      isStaticData: true,
      data: this.data,
      isTableResponsive: true,
      rowStripedColour: 'brand-main',
      isSearchTextFilter: false,
      checkboxConfig: {
        isShow: false,
        colour: 'dark-grey'
      }
    };
    if (this.sampleData.length > 0) {
      this.tableData.pagination = {
        maxSize: this.maxSize,
        totalRows: this.sampleData.length,
        align: 'end',
      }
    }
    if (this.tableData.isStaticData) {
      this.kTableGridService.pushData(this.tableData);
    }
  }

  goToExposure() {
    this.router.navigate(['asbestosis/exposure/outline-exposure-to-dust/',this.claimId,this.taskId])
  }
}
